// Program maps: list, one map, and write operations (create, update, publish, unpublish, archive, seed)
export const FETCH_PROGRAM_MAPS = 'DP_FETCH_PROGRAM_MAPS';
export const FETCH_PROGRAM_MAPS_SUCCESS = 'DP_FETCH_PROGRAM_MAPS_SUCCESS';
export const FETCH_PROGRAM_MAPS_ERROR = 'DP_FETCH_PROGRAM_MAPS_ERROR';
export const FETCH_PROGRAM_MAP = 'DP_FETCH_PROGRAM_MAP';
export const FETCH_PROGRAM_MAP_SUCCESS = 'DP_FETCH_PROGRAM_MAP_SUCCESS';
export const FETCH_PROGRAM_MAP_ERROR = 'DP_FETCH_PROGRAM_MAP_ERROR';
export const CLEAR_PROGRAM_MAP = 'DP_CLEAR_PROGRAM_MAP';
export const SAVE_PROGRAM_MAP = 'DP_SAVE_PROGRAM_MAP';
export const SAVE_PROGRAM_MAP_SUCCESS = 'DP_SAVE_PROGRAM_MAP_SUCCESS';
export const SAVE_PROGRAM_MAP_ERROR = 'DP_SAVE_PROGRAM_MAP_ERROR';
